var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { PerformanceReviewSectionsEnum, UserRoles } from '@workalizer/shared';
export var PERFORMANCE_INSIGHTS_SECTIONS = [
    PerformanceReviewSectionsEnum.OVERVIEW,
    PerformanceReviewSectionsEnum.COMMUNICATION,
    PerformanceReviewSectionsEnum.INITIATIVE_AND_OWNERSHIP,
    PerformanceReviewSectionsEnum.SCHEDULE_AND_ATTENDANCE,
    PerformanceReviewSectionsEnum.TIME_MANAGEMENT,
    PerformanceReviewSectionsEnum.WORK_LIFE_BALANCE,
    PerformanceReviewSectionsEnum.POLICY_COMPLIANCE,
    PerformanceReviewSectionsEnum.AI_ADOPTION_AND_USAGE,
    PerformanceReviewSectionsEnum.DAILY_TIMELINE
];
export var canAccessManagerInsightsSection = function (_a) {
    var isAdmin = _a.isAdmin, role = _a.role;
    return isAdmin || role === UserRoles.MANAGER;
};
export var getPerformanceInsightsSections = function (canAccessManagerSection) { return __spreadArray(__spreadArray([], PERFORMANCE_INSIGHTS_SECTIONS, true), (canAccessManagerSection
    ? [PerformanceReviewSectionsEnum.MANAGER_ONLY]
    : []), true); };
export var resolvePerformanceInsightsSection = function (pageSection, allowedSections) {
    return pageSection && allowedSections.includes(pageSection)
        ? pageSection
        : PERFORMANCE_INSIGHTS_SECTIONS[0];
};
